module.exports = "<span class=\"count\">0</span>"